import { Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { MetaService } from '../../services/meta/meta.service';

@Component({
  selector: 'loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit, OnDestroy {

  @Input() big = false;
  @HostBinding('class.big') isBig: boolean;
  color = '#FFFFFF';

  private subscriptions = [];

  constructor(private meta: MetaService) {
    this.subscriptions.push(this.meta.$changed.subscribe(changed => {
      this.color = this.meta.getString('ibexTouch.contentText', this.color);
    }));
  }

  ngOnInit(): void {
    this.isBig = this.big;
  }

  ngOnDestroy() {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
    this.subscriptions.length = 0;
  }

}
